var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Countdown pointer",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.second <= 0 ? _vm.codeMsg:'剩余'+_vm.second+'s')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }